import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { MsalProvider } from '@azure/msal-react';
import { QueryProvider } from "./providers/QueryProvider";
// import { startMocking } from "./mocks/browser";
import { MantineProvider } from "./providers/MantineProvider";
import { createRouter } from "./router";
import { msalInstance } from "./api/auth";

import "./index.css";


// Disable Mock Service Worker - using real backend API
// if (process.env.NODE_ENV === 'development') {
//     startMocking().catch(console.error);
// }

// Create router instance
const router = createRouter()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Wait for MSAL to process any in-flight redirect response before rendering.
// This prevents MsalAuthenticationTemplate from starting a second redirect
// before the first one has been processed, which causes interaction_in_progress errors
// and a blank page on first load of the day.
msalInstance.handleRedirectPromise()
  .then(() => {

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryProvider>
            <MantineProvider>
              <RouterProvider router={router} />
            </MantineProvider>
          </QueryProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error('MSAL redirect handling failed:', error);
    // Still render the app — MsalAuthenticationTemplate will handle re-auth

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryProvider>
            <MantineProvider>
              <RouterProvider router={router} />
            </MantineProvider>
          </QueryProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  });
